export default __webpack_public_path__ + "static/media/image-app-design.1f02d5b7.jpg";